import { rpc } from '@server/infrastructure/rpc'

import {
  UpdateUserLocaleRequest,
  normalizeUserLanguageCode,
  updateUserLocaleRequestSchema,
  updateUserLocaleResponseSchema,
} from '../model'

type RawUpdateUserLocaleResponse = {
  timezoneCode: string
  languageCode: string | null
}

export const updateUserLocale = async (request: UpdateUserLocaleRequest, token?: string) => {
  const parsedRequest = updateUserLocaleRequestSchema.parse(request)

  if (!token) {
    throw new Error('Authorization token is required to update user locale.')
  }

  const response = await rpc.api.v1.users.locale.$patch(
    {
      json: parsedRequest,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to update user locale: ${response.status}`)
  }

  const responseData = (await response.json()) as RawUpdateUserLocaleResponse

  return updateUserLocaleResponseSchema.parse({
    ...responseData,
    languageCode: normalizeUserLanguageCode(responseData.languageCode),
  })
}
